import React, { useState, useRef, useEffect } from 'react';
import { Select, Input, Button } from 'antd';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';

const { Option } = Select;

const CreateTaskBar = ({ onAddTask, onClose }) => {
  const [taskTitle, setTaskTitle] = useState('');
  const [selectedTypeId, setSelectedTypeId] = useState(1);
  const [selectedType, setSelectedType] = useState('TASK');

  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        !event.target.closest('.ant-select-dropdown')
      ) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const ISSUE_TYPE = [
    { id: 1, label: 'Task', icon: TaskObject },
    { id: 2, label: 'Story', icon: StoryObject },
    { id: 3, label: 'Bug', icon: BugObject },
  ];

  const handleAdd = () => {
    if (taskTitle.trim()) {
      onAddTask({
        issue_title: taskTitle,
        issue_status: 'TO DO',
        issue_type_id: selectedTypeId,
        issue_type: selectedType,
      });
    }

    setTaskTitle('');
    setSelectedTypeId(1);
    setSelectedType(' ');
    onClose();
  };

  return (
    <div ref={wrapperRef}>
      <div
        style={{
          border: '2px solid #722ed1',
          borderRadius: '4px',
          padding: '12px',
          background: '#f0f5ff',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <Select
          value={selectedTypeId}
          onChange={(value) => {
            setSelectedTypeId(value);
            const typeObj = ISSUE_TYPE.find((t) => t.id === value);
            setSelectedType(typeObj?.label || '');
          }}
          style={{ width: 150 }}
          getPopupContainer={(trigger) => trigger.parentElement}
        >
          {ISSUE_TYPE.map(({ id, label, icon: Icon }) => (
            <Option key={id} value={id}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <Icon width={35} />
                <span>{label}</span>
              </div>
            </Option>
          ))}
        </Select>

        <Input
          placeholder="What needs to be done?"
          value={taskTitle}
          onChange={(e) => setTaskTitle(e.target.value)}
          onPressEnter={handleAdd}
          style={{ flex: 1 }}
          autoFocus
        />

        <Button
          style={{ backgroundColor: '#722ed1', color: 'white' }}
          onClick={handleAdd}
        >
          Add
        </Button>
      </div>
    </div>
  );
};

export default CreateTaskBar;
